import type { NavigationButton, LinkNavigationButton, DropdownNavigationButton, DividerNavigationButton, MenuItem, DividerMenuItem } from '@core/ui/navigation';
import { createHomeTypeQuery } from './utils';

const createDivider = (): DividerNavigationButton => ({
  id: `divider-${Math.random().toString(36).substr(2, 9)}`,
  buttonVariant: 'divider',
});

const createMenuDivider = (): DividerMenuItem => ({
  id: `divider-${Math.random().toString(36).substr(2, 9)}`,
  type: 'divider',
});

const createLinkButton = (id: string, label: string, href: string, external?: boolean, metadata?: { handler: string }): LinkNavigationButton => ({
  id,
  buttonVariant: 'link',
  label,
  href,
  external,
  metadata,
});

const createDropdownButton = (id: string, label: string, items: MenuItem[]): DropdownNavigationButton => ({
  id,
  buttonVariant: 'dropdown',
  label,
  items,
});

const createLinkItem = (id: string, label: string, href: string, external?: boolean, metadata?: { handler: string }): MenuItem => ({
  id,
  type: 'link',
  label,
  href,
  external,
  metadata,
});

const createTemplatedLinkItem = (id: string, template: string, href: string): MenuItem => ({
  id,
  type: 'link',
  template,
  href,
});

export const mobileNavigationItems: NavigationButton[] = [
  createDropdownButton('buy', 'Buy', [
    createTemplatedLinkItem('city-real-estate', '{city} Real Estate', '/{city-slug}-real-estate'),
    createLinkItem('houses-sale', 'Houses for Sale', '/{city-slug}-real-estate/houses'),
    createLinkItem('condos-sale', 'Condos for Sale', '/{city-slug}-real-estate/condos'),
    createLinkItem('townhouses-sale', 'Townhouses for Sale', '/{city-slug}-real-estate/townhouses'),
    createLinkItem('open-houses', 'Open Houses', '/{city-slug}-real-estate/open-houses'),
    createLinkItem('recently-sold', 'Recently Sold', '/{city-slug}-real-estate/sold'),
    createMenuDivider(),
    createLinkItem('new-listings', 'New Listings', '/{site-location}-real-estate?sort=-date'),
    createLinkItem('new-construction', 'New Construction', '/newhomes'),
    createLinkItem('buying-info', 'Information about Buying', 'https://www.zoocasa.com/blog/category/buying-a-home/', true),
  ]),
  createDropdownButton('rent', 'Rent', [
    createTemplatedLinkItem('city-rentals', '{city} Rentals', '/{city-slug}-real-estate/for-rent'),
    createLinkItem('houses-rent', 'Houses for Rent', `/{city-slug}-real-estate/filter?rental=true&${createHomeTypeQuery(['house'])}`),
    createLinkItem('condos-rent', 'Condos for Rent', `/{city-slug}-real-estate/filter?rental=true&${createHomeTypeQuery(['condo'])}`),
    createLinkItem('townhouses-rent', 'Townhouses for Rent', `/{city-slug}-real-estate/filter?rental=true&${createHomeTypeQuery(['townhouse'])}`),
    createMenuDivider(),
    createLinkItem('new-rental-listings', 'New Listings', '/{site-location}-real-estate/for-rent?sort=-date'),
    createLinkItem('renting-info', 'Information about Renting', 'https://www.zoocasa.com/blog/?s=rent', true),
  ]),
  createDropdownButton('sell', 'Sell', [
    createTemplatedLinkItem('city-recently-sold', '{city} Recently Sold', '/{city-slug}-real-estate/sold'),
    createLinkItem('sell-with-zoocasa', 'Sell with Zoocasa', 'https://zoocasa.ac-page.com/home-sellers-guide', true),
    createLinkItem('home-appraisal', 'Home Appraisal', '/home-appraisal'),
    createMenuDivider(),
    createLinkItem('selling-info', 'Information about Selling', 'https://www.zoocasa.com/blog/category/selling-your-home/', true),
  ]),
  createDivider(),
  createLinkButton('market-insights', 'News & Insights', 'https://www.zoocasa.com/blog/', true),
  createLinkButton('newsletter', 'Newsletter', 'https://zoocasa.ac-page.com/newsletter'),
  createDropdownButton('careers', 'Careers', [
    createLinkItem('headquarters', 'Headquarters', 'https://jobs.jobvite.com/exprealty/jobs', true),
    createLinkItem('agents', 'Agents', 'https://accelerator.zoocasa.com', true),
  ]),
  createLinkButton('about-us', 'About Us', '/about-us'),
  createLinkButton('sitemap', 'Sitemap', '/sitemap'),
]; 